// extracted by mini-css-extract-plugin
export default {"collapsePanel":"styles_collapsePanel__xGdLF"};